import { FC, useState, useEffect } from "react";
import { Input, Select, Modal, Form, Switch } from "antd";

import { t, CoreResource } from "shared/plugins/localization";
import { Cancel, Save } from "shared/constants/define-localization";

import { QRCodeComponent } from "shared/components/qr-code/qr-code";
import { getQrCode } from "states/user-management/user-management.api";

interface IStaffModalProps {
  userId: string;
  onModal: boolean;
  closeModal: () => void;
}
export const StaffQrModalComponent: FC<IStaffModalProps> = (props) => {
  const { userId, onModal, closeModal } = props;
  const [passCode, setPassCode] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const handleCloseModal = () => closeModal();
  useEffect(() => {
    if (userId) {
      setLoading(true);
      getQrCode(userId)
        .then((result) => {
          setLoading(false);
          setPassCode(result.data);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [onModal]);
  const getCurrentHost = () => {
    return `${window.location.protocol === "http:" ? "http://" : "https://"}${
      window.location.hostname
    }/admin/login`;
  };
  return (
    <Modal
      title={
        <div
          style={{
            width: "100%",
            cursor: "move",
          }}
          onBlur={() => {}}
          // end
        >
          Qr code đăng nhập cho nhân viên
        </div>
      }
      confirmLoading={loading}
      centered={true}
      visible={onModal}
      onCancel={() => {
        handleCloseModal();
        setPassCode("");
      }}
      cancelText={"Hủy"}
    >
      {passCode && (
        <QRCodeComponent value={`${getCurrentHost()}?passCode=${passCode}`} />
      )}
    </Modal>
  );
};
